// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"vs_a bhb_b"};